import { NgOptimizedImage } from '@angular/common';
import { Component, EventEmitter, inject, Inject, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ProductStockComponent } from '@scalefast/components/product';
import { StoreConfigService } from '@scalefast/config-angular';
import { CartProduct, createCartProductFromProduct, Product, ProductPrice, ProductStock } from '@scalefast/core';
import { LoginService } from '@scalefast/ecommerce-core';
import { MISSING_PRODUCT_IMAGE_URL } from 'src/app/app.tokens';
import { TranslateProductFieldPipe } from 'src/app/shared/pipes/translate-product-field.pipe';
import { AppProductPriceComponent } from '../../../components/product/product-price/product-price.component';

@Component({
  selector: 'app-product-added-to-cart',
  templateUrl: './product-added-to-cart.component.html',
  styleUrls: ['./product-added-to-cart.component.scss'],
  standalone: true,
  imports: [AppProductPriceComponent, ProductStockComponent, NgOptimizedImage, TranslateProductFieldPipe],
  providers: [TranslateProductFieldPipe],
})
export class AppProductAddedToCartComponent implements OnChanges {
  // This property is used in the product list case where there's no access to any product data
  @Input() cartProduct: CartProduct | undefined;
  // This property is used in the product page case using the sam-pr-added-to-cart component
  @Input() product: Product | undefined;
  @Input() productPrice: ProductPrice | undefined;
  @Input() productStock: ProductStock | undefined;
  @Input() quantity = 1;
  @Input() cartUrl = 'cart';
  @Output() closeModalEvent = new EventEmitter<void>();
  @Output() addCrossSellProductToCartEvent = new EventEmitter<Product>();

  productImg = '';
  loginUrl: string;

  constructor(
    @Inject(MISSING_PRODUCT_IMAGE_URL)
    public missingProductImageUrl: string,
    private loginService: LoginService,
    private translateProductFieldPipe: TranslateProductFieldPipe,
  ) {
    if (!this.cartProduct && this.product) {
      this.cartProduct = createCartProductFromProduct(this.product);
    }
    this.loginUrl = inject(StoreConfigService).getCustomRoutes()?.login ?? 'login';
  }

  get productTitle(): string | undefined {
    if (this.product) {
      return this.translateProductFieldPipe.transform(this.product, 'title');
    }

    if (this.cartProduct) {
      return this.translateProductFieldPipe.transform(this.cartProduct.product, 'title');
    }

    return '';
  }

  get productImage(): string | undefined {
    return !this.cartProduct && this.product ? this.product.imageUrl : this.cartProduct?.image;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.cartProduct && changes.cartProduct) {
      this.setProduct(this.cartProduct);
    }
  }

  setProduct(cartProduct: CartProduct): void {
    this.quantity = cartProduct.quantity;

    if (this.productPrice) {
      this.productPrice.currencies[0].prices[0].price = cartProduct.price;
    }
    if (this.productStock) {
      this.productStock.stock = cartProduct.stock;
    }
  }

  closeModal(): void {
    this.closeModalEvent.emit();
  }

  proceedToCart(): void {
    this.closeModalEvent.emit();
    /**
     * @FIXME Here we SHOULD use angular's router and navigate() method instead of window.location,
     * but because of the cart page is hosted on v4 connection we need to reload the page, and we can't do that with angular router navigate.
     * Once the cart page is hosted in v5 we need to make the switch to angular router navigate.
     */
    /* window.location.href = this.loginService.isLoggedSync() ? this.cartUrl : `${this.loginUrl}?redirectTo=/cart`; */
    window.location.href = this.cartUrl;
  }

  addCrossSellProductToCart(crossSellProduct: Product): void {
    // Set the new cartProduct on the modal
    this.addCrossSellProductToCartEvent.emit(crossSellProduct);
  }
}
